import React from 'react'

function FilterTab({ changeHandeler, status }) {

  return (
    <>
      <select
        className="select select-sm select-bordered uppercase h-10 w-48"
        onChange={(e) => changeHandeler(e.target.value)}>
        {
          status.map((item, index) => (
            <option key={index}>{item}</option>
          ))
        }
      </select>
    </>
  )
}

export default FilterTab
